import React, { useState } from "react";
import './ReturnCalculator.css';

const ReturnCalculator = () => {
  const [investment, setInvestment] = useState("");
  const [rate, setRate] = useState("");
  const [years, setYears] = useState("");
  const [returns, setReturns] = useState(null);

  const calculateReturns = () => {
    const finalAmount = investment * Math.pow(1 + rate / 100, years);
    setReturns(finalAmount.toFixed(2));
  };

  return (
    <div className="calculator-container">
      <h2>Return Calculator</h2>
      <input
        type="number"
        placeholder="Investment Amount"
        value={investment}
        onChange={(e) => setInvestment(e.target.value)}
      />
      <input
        type="number"
        placeholder="Annual Interest Rate (%)"
        value={rate}
        onChange={(e) => setRate(e.target.value)}
      />
      <input
        type="number"
        placeholder="Years"
        value={years}
        onChange={(e) => setYears(e.target.value)}
      />
      <button onClick={calculateReturns}>Calculate</button>
      {returns && <h3>Final Value: ₹{returns}</h3>}
    </div>
  );
};

export default ReturnCalculator;
